import { render, staticRenderFns } from "./SpecificKeyword.vue?vue&type=template&id=22f1dc14&scoped=true"
import script from "./SpecificKeyword.vue?vue&type=script&lang=js"
export * from "./SpecificKeyword.vue?vue&type=script&lang=js"
import style0 from "./SpecificKeyword.vue?vue&type=style&index=0&id=22f1dc14&prod&scoped=true&lang=css"
import style1 from "./SpecificKeyword.vue?vue&type=style&index=1&id=22f1dc14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f1dc14",
  null
  
)

export default component.exports